import { render } from "./OverviewHeader.vue?vue&type=template&id=5b0e6b4a&scoped=true"
import script from "./OverviewHeader.vue?vue&type=script&lang=js"
export * from "./OverviewHeader.vue?vue&type=script&lang=js"

import "./OverviewHeader.vue?vue&type=style&index=0&id=5b0e6b4a&lang=scss&scoped=true"
import "./OverviewHeader.vue?vue&type=style&index=1&id=5b0e6b4a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0e6b4a"]])

export default __exports__